<mat-checkbox class="mat-option"
        [disableRipple]="true"
        [indeterminate]="isIndeterminate()"
        [checked]="isChecked()"
        (click)="$event.stopPropagation()"
        (change)="toggleSelection($event)">
    {{text}}
</mat-checkbox>